import { useParams } from "react-router";
import { MaterialsShell } from "@/components/materials/MaterialsShell";
import type { MaterialsPageContext } from "@/lib/materials-folder-tree";

/**
 * 素材库页面：接 `/api/v1/materials/*` 真数据。
 * 路由支持企业、品牌与单站三种工作根。
 */
export default function MaterialsPage() {
  const { accountId = "", brandId, siteId } = useParams();
  const context: MaterialsPageContext = siteId
    ? {
        kind: "brand_site",
        brandId: brandId ?? null,
        brandSiteId: siteId,
      }
    : brandId
      ? {
          kind: "brand",
          brandId,
          brandSiteId: null,
        }
      : {
          kind: "enterprise",
          brandId: null,
          brandSiteId: null,
        };

  return <MaterialsShell accountId={accountId} context={context} />;
}
